import * as React from "react"
import Switch from "@mui/material/Switch"
import {Box, Grid, styled, Typography} from "@mui/material"
import ClearIcon from "@mui/icons-material/Clear"
import CheckIcon from "@mui/icons-material/Check"

const Thumb = styled(Box)(({theme}) => theme.Switch.Thumb)
const Label = styled(Typography)(({theme}) => theme.Switch.Label)
const Wrapper = styled(Grid)(({theme}) => theme.Switch.Wrapper)

const SwitchWidget = ({widget, value, onValueChange}) => {
    const {disabled, text} = widget
    const onTriggerSwitch = (event) => {
        onValueChange(event.target.checked)
    }

    return (
        <Wrapper
            container
            wrap="noWrap"
            justifyContent="space-between"
            alignItems="center">
            {text && (
                <Grid item>
                    <Label>{text}</Label>
                </Grid>
            )}
            <Grid item>
                <Switch
                    sx={{m: 1, mr: 0}}
                    checked={Boolean(value)}
                    onChange={onTriggerSwitch}
                    disabled={disabled}
                    defaultChecked={!disabled}
                    icon={
                        <Thumb>
                            <ClearIcon />
                        </Thumb>
                    }
                    checkedIcon={
                        <Thumb>
                            <CheckIcon />
                        </Thumb>
                    }
                />
            </Grid>
        </Wrapper>
    )
}

export default SwitchWidget
